import script from "./AnomalyToolBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AnomalyToolBar.vue?vue&type=script&setup=true&lang=js"

import "./AnomalyToolBar.vue?vue&type=style&index=0&id=61d60db0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d60db0"]])

export default __exports__